const getters = {
  token: state => state.user.token,
  userinfo: state => state.user.userinfo,
  sidebarItem:state => state.sideBar.sidebar,
  tags: state => state.tagsView.tags,
};
export default getters
